import { action, makeObservable } from 'mobx';
import ModalDelegate from './modalDelegate';

export default class SafeguardModalDelegate extends ModalDelegate {
  public onAction: () => Promise<void> | void;
  public onClose?: () => void;

  constructor(onAction: () => Promise<void> | void, onClose?: () => void) {
    super();
    this.onAction = onAction;

    makeObservable<SafeguardModalDelegate, 'onAction'>(this, {
      onAction: action.bound,
    });

    if (onClose) {
      this.onClose = onClose;
      makeObservable<SafeguardModalDelegate, 'onClose'>(this, {
        onClose: action.bound,
      });
    }
  }
}
